// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FundTwoToneSvg from "@fishx/icons-svg/es/asn/FundTwoTone";
import FishxIcon from '../components/FishxIcon';

var FundTwoTone = function FundTwoTone(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FundTwoToneSvg
  }));
};

FundTwoTone.displayName = 'FundTwoTone';
export default React.forwardRef(FundTwoTone);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FundTwoTone.js
// module id = 2854
// module chunks = 0